export default {
    namespaced: true,
    state: {
        KEY_COMPETENCIES: [
            "LITERACY",
            "MULTILINGUAL",
            "MATHEMATICAL",
            "DIGITAL",
            "PERSONAL",
            "CITIZEN",
            "ENTERPRENEURIAL",
            "CULTURAL_AWARENESS"
        ],
        SUBJECTS: [
            "SOCIAL_SCIENCES",
            "NATURAL_SCIENCES",
            "MATH",
            "LANGUAGE",
            "BIOLOGY_GEOLOGY",
            "GEOGRAPHY_HISTORY",
            "FOREIGN_LANGUAGE",
            "PHYSICAL_EDUCATION"
        ],
        
    },
    mutations: {
        
    },
    getters: {
        
    },
};
